import React, { useEffect } from "react";
import './Services.css';

const Services = () => {


    const cards = [
        {
            id: 1,
            image: require('../assets/images/tankreinigung-ei.jpg'),
            title: 'Tankreinigung',
            describtion: 'Gründliche Tankreinigung für optimale Leistung',
            link: '/tankreinigung'
        },
        {
            id: 2,
            image: require('../assets/images/card-light-corrosion.png'),
            title: 'Leichter Korrosionsschutz',
            describtion: 'Effektive Korrosionsschutzlösungen für Ihre Tanks',
            link: '/leichterKorrosionsschutz'
        },
        {
            id: 3,
            image: require('../assets/images/straßenlaternen.jpg'),
            title: 'Straßenlaternenmastlackierung',
            describtion: 'Professionelle Mastlackierung für langlebigen Korrosionsschutz und frischen Look.',
            link: '/strassenlaternenmastlackierung'
        }
    ];


    


    {/*return(
        <section className="services" id="services">
            <h3>Unsere Services</h3>
            <h2>Umfassende Lösungen für Sie</h2>
                <section className="cards-section">
                    {cards.map(card => (
                        <div key={card.id} className="card">
                            <img src={card.image} alt={card.title} className="card-image"/>
                            <a href={card.link} className="card-title">{card.title}</a>
                            <p className="card-description">{card.describtion}</p>
                        </div>
                    ))}
             </section>
        </section>
    );*/}

    return(
        <section className="services" id="services">
            <h3>Unsere Services</h3>
            <h2>Umfassende Lösungen für Sie</h2>
                <section className="cards-section">
                    {cards.map(card => (
                        <a href={card.link} className="card-title">
                            <div key={card.id} className="card">
                                <img src={card.image} alt={card.title} className="card-image"/>
                                <p>{card.title}</p>
                                <p className="card-description">{card.describtion}</p>
                            </div>
                        </a>
                    ))}
             </section>
        </section>
    );
};

export default Services;